import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App'
import './style.css'
import '../node_modules/bootstrap/dist/css/bootstrap.css'
import {BrowserRouter} from 'react-router-dom'

ReactDOM.createRoot(document.querySelector('#root')).render(<BrowserRouter><App /></BrowserRouter>)
